import { render } from "./SelectedPVTReport.vue?vue&type=template&id=aeb6466a"
import script from "./SelectedPVTReport.vue?vue&type=script&lang=js"
export * from "./SelectedPVTReport.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__